export default "<template>\r\n  <v-input :success-messages=\"['Success']\" success disabled>Input</v-input>\r\n</template>\r\n";